import React from "react";
import AdminLayout from "../../layouts/AdminLayout";

export default function AdminSystem() {
  return (
    <AdminLayout title="Admin System">
      <div className="space-y-6">
        <div>
          <p className="text-sm text-slate-600">Read-only system status.</p>
        </div>
        <div className="card p-6 text-sm text-slate-600">
          No system status data available yet.
        </div>
      </div>
    </AdminLayout>
  );
}
